import { httpClient } from '@/utils/http'
/**
 * 获取消息列表
 * @param params
 * @returns
 */
export class MessageAPI {
  static async getMessageList(params: any): Promise<any> {
    return httpClient.post<any>('/getDialogueList', params)
  }
  /**
   * 删除对话
   * @param params
   * @returns
   */
  static async deleteDialogue(params: any): Promise<any> {
    return httpClient.post<any>('/dialogueDelete', params)
  }

  /**
   * 重置对话
   * @param params
   * @returns
   */
  static async resetDialogue(params: any): Promise<any> {
    return httpClient.post<any>('/resetChatRecords', params)
  }

  /**
   * 举报类型
   * @param params
   * @returns
   */
  static async reportType(): Promise<any> {
    return httpClient.post<any>('/reportType')
  }
  /**
   * 举报
   * @param params
   * @returns
   */
  static async submitReport(params: any): Promise<any> {
    return httpClient.post<any>('/report', params)
  }
  /**
   * 收藏取消收藏数字人
   * @param params
   * @returns
   */
  static async favoriteRole(params: any): Promise<any> {
    return httpClient.post<any>('/favoriteRole', params)
  }
  /**
   * 获取聊天记录（分页）
   * @param params
   * @returns
   */
  static async getChatRecordsPaginated(params: {
    roleId: string|number
    page: number
    pageSize: number
  }): Promise<any> {
    return httpClient.post<any>('/getChatRecords', params)
  }
  /**
   * 消息相关API接口
   */

  static async sendMessage(params: any): Promise<any> {
    console.log('📤 API调用 sendMessage:', params)
    return httpClient.post<any>('/submitChat', params)
  }
  /**
   * 删除聊天记录
   * @param params
   * @returns
   */
  static async deleteChatRecords(params: any): Promise<any> {
    return httpClient.post<any>('/delChatRecords', params)
  }
  /**
   * 翻译
  */
  static async translate(params: any): Promise<any> {
    return httpClient.post<any>('/translate', params)
  }
  /**
   * 角色相册
  */
  static async roleAlbum(params: any): Promise<any> {
    return httpClient.post<any>('/roleAlbum', params)
  }
  /**
   * 解锁相册
  */
 static async unlockAlbum(params: any): Promise<any> {
  return httpClient.post<any>('/unlockAlbum', params)
 }
 /**
  *   模型列表
 */
 static async modelList(params: any): Promise<any> {
  return httpClient.post<any>('/chatModelList', params)
 }
 /**
  * 设置模型
 */
 static async setUserChatModel(params: any): Promise<any> {
  return httpClient.post<any>('/setUserChatModel', params)
 }
 /**
  * 设置背景图
 */
 static async setRoleImage(params: any): Promise<any> {
  return httpClient.post<any>('/setRoleImage', params)
 }
 /**
  * 数字人详情接口
 */
 static async getRoleDetail(params: any): Promise<any> {
  return httpClient.post<any>('/getRoleDetail', params)
 }
 /**
  * 获取图片
 */
 static async submitRecordImag(params: any): Promise<any> {
  return httpClient.post<any>('/submitRecordImag', params)
 }
 /**
  * 场景列表
 */
 static async getRoleScene(params: any): Promise<any> {
  return httpClient.post<any>('/getRoleScene', params)
 }
 /**
  * 切换场景
 */
 static async switchRoleScene(params: any): Promise<any> {
  return httpClient.post<any>('/setRoleScene', params)
 }
 /**
  * 获取单条聊天记录
 */
 static async getChatMsg(params: any): Promise<any> {
  return httpClient.post<any>('/getChatMsg', params)
 }
 /**
  * 设置聊天风格
 */
 static async setUserModelConfig(params: any): Promise<any> {
  return httpClient.post<any>('/setUserModelConfig', params)
 }
 /**
  * 编辑聊天记录
 */
 static async editRecordInfo(params: any): Promise<any> {
  return httpClient.post<any>('/editRecordInfo', params)
 }
 /**
  * 购买体力
 */
 static async getBuyStrength(params: any): Promise<any> {
  return httpClient.post<any>('/buyStrength', params)
 }
 /**
  * 获取快速回复
 */
 static async getQuickReply(params: any): Promise<any> {
  return httpClient.post<any>('/getQuickReplyList', params)
 }
}
export default MessageAPI
